function addMorphDelta(morph, out, outOffset, componentOffset, weightsOverride) {
  let x = out[outOffset];
  let y = out[outOffset + 1];
  let z = out[outOffset + 2];
  const activeWeights = weightsOverride ?? morph.weights;
  const targetCount = Math.min(morph.count, morph.targets.length);
  for (let t = 0; t < targetCount; t++) {
    const weight = activeWeights[t] ?? 0;
    if (weight === 0) {
      continue;
    }
    const positions = morph.targets[t].positions;
    x += positions[componentOffset] * weight;
    y += positions[componentOffset + 1] * weight;
    z += positions[componentOffset + 2] * weight;
  }
  out[outOffset] = x;
  out[outOffset + 1] = y;
  out[outOffset + 2] = z;
}
const _boneTransformScratch = [0, 0, 0];
function skinVertexToRef(boneMatrices, joints, weights, joints1, weights1, vertexIndex, x, y, z, wCoord, out, outOffset) {
  let rx = 0;
  let ry = 0;
  let rz = 0;
  const base = vertexIndex * 4;
  for (let i = 0; i < 4; i++) {
    const weight = weights[base + i] ?? 0;
    if (weight !== 0) {
      transformByBoneToRef(boneMatrices, joints[base + i] ?? 0, x, y, z, wCoord, _boneTransformScratch);
      rx += _boneTransformScratch[0] * weight;
      ry += _boneTransformScratch[1] * weight;
      rz += _boneTransformScratch[2] * weight;
    }
  }
  if (joints1 && weights1) {
    for (let i = 0; i < 4; i++) {
      const weight = weights1[base + i] ?? 0;
      if (weight !== 0) {
        transformByBoneToRef(boneMatrices, joints1[base + i] ?? 0, x, y, z, wCoord, _boneTransformScratch);
        rx += _boneTransformScratch[0] * weight;
        ry += _boneTransformScratch[1] * weight;
        rz += _boneTransformScratch[2] * weight;
      }
    }
  }
  out[outOffset] = rx;
  out[outOffset + 1] = ry;
  out[outOffset + 2] = rz;
}
function transformByBoneToRef(boneMatrices, joint, x, y, z, wCoord, out) {
  const o = joint * 16;
  out[0] = boneMatrices[o] * x + boneMatrices[o + 4] * y + boneMatrices[o + 8] * z + boneMatrices[o + 12] * wCoord;
  out[1] = boneMatrices[o + 1] * x + boneMatrices[o + 5] * y + boneMatrices[o + 9] * z + boneMatrices[o + 13] * wCoord;
  out[2] = boneMatrices[o + 2] * x + boneMatrices[o + 6] * y + boneMatrices[o + 10] * z + boneMatrices[o + 14] * wCoord;
}

export { addMorphDelta, skinVertexToRef };
//# sourceMappingURL=deformation-math.js.map
